const state = {
  cluviPay: {
    payment_method: {},
    purchase: {id:0},
    msg:{},
    pse: {process: 0}
  },
  profileSessionCluvipay: {id:0},
};

const getters = {
};

const actions = {
};

const mutations = {
  SetProfileSessionCluvipay(state, data) {
    state.profileSessionCluvipay = data;
  },
  SetCluviPay(state, data) {
    if(data.purchase) state.cluviPay.purchase = data.purchase;
    if(data.msg) state.cluviPay.msg = data.msg.transaction_status;
    if(data.payment_method) state.cluviPay.payment_method = data.payment_method;
    if(data.pse) state.cluviPay.pse = data.pse;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
